export const SHORT_WORD_LENGTH = 10;

export const READING_REMINDER_TEXT = 'Read before you click.';

export const DONE_MESSAGE = 'YOU ARE DONE';
export const COMPLETED_ALL_FORMS_MESSAGE = 'You have completed all available forms';
export const NO_ASSESSMENT_MESSAGE = 'No Assessment Assigned';

export const TRC_CONFIRM_READING = 'Are you done reading?';
export const TRC_CONFIRM_BOOK_COMPLETE = 'Are you done answering all the questions?';

export const ACTIVITY_TIMER_MESSAGE = 'Time is up.';

export const THUMB_BUTTON_TEXT = {
    YES: 'Yes',
    NO: 'No',
};

export const THUMB_BUTTON_TEXT_SPANISH = {
    YES: 'Sí',
    NO: 'No',
};

export const NBSP = '\xa0';

export const APOSTROPHE = "'";

export const SPANISH_ALPHABET = [
    'a',
    'g',
    'n',
    't',
    'á',
    'h',
    'ñ',
    'u',
    'b',
    'i',
    'o',
    'ú',
    'c',
    'í',
    'ó',
    'ü',
    'd',
    'j',
    'p',
    'v',
    'e',
    'k',
    'q',
    'w',
    'é',
    'l',
    'r',
    'x',
    'f',
    'm',
    's',
    'y',
    'z',
];

export const ARIA_LABELS = {
    START_ASSESSMENT: 'Start the assessment',
    RESUME_ASSESSMENT: 'Resume the assessment',
    START_ACTIVITY: 'Start the read-aloud activity',
    START_RECORDING: 'Start recording',
    STOP_RECORDING: 'Stop recording',
    GO_TO_NEXT_STEP: 'Go to next step',
    PLAY_AUDIO: 'Play audio',
    START_BOOK: 'Start the book',
    GO_TO_NEXT_BOOK_PAGE: 'Go to next book page',
    GO_TO_PREV_BOOK_PAGE: 'Go to previous book page',
    GO_TO_NEXT_QUESTION: 'Go to next question',
    GO_TO_PREV_QUESTION: 'Go to previous question',
    DONE: 'Done',
    ASK_ALYX_AGAIN: 'Ask Alyx to say the directions again',
    PAUSE_DIRECTIONS: 'Pause the directions',
    CONTINUE_DIRECTIONS: 'Continue the directions',
    HIDE_CAPTION: 'Hide caption',
    SCROLL_UP: 'Scroll up',
    SCROLL_DOWN: 'Scroll down',
};
